import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/[...not-found]/not-found.tsx");
